module.exports = __webpack_public_path__ + "img/retro_sec2.68baafb3.jpg";